export function enumKeys(enumObj: any) {
  return Object.keys(enumObj).filter((key) => !isNaN(Number(enumObj[key])));
}
